/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'support-help': {
    width: 16,
    height: 16,
    viewBox: '13 13 24 24',
    data: '<path pid="0" d="M25.5 15.313c5.626 0 10.188 4.56 10.188 10.187 0 5.626-4.562 10.188-10.188 10.188S15.312 31.125 15.312 25.5 19.875 15.312 25.5 15.312zm2.9 14.236a4.964 4.964 0 01-2.9.93 4.964 4.964 0 01-2.9-.93l-2.553 2.553a8.523 8.523 0 005.453 1.96 8.525 8.525 0 005.453-1.96zm-9.503-9.502a8.523 8.523 0 00-1.96 5.453c0 2.072.735 3.972 1.96 5.453l2.554-2.553c-.585-.816-.93-1.817-.93-2.899s.345-2.083.93-2.9zm13.204 0L29.549 22.6c.585.816.93 1.817.93 2.899s-.345 2.083-.93 2.9l2.553 2.553a8.523 8.523 0 001.96-5.453 8.525 8.525 0 00-1.96-5.453zM25.5 22.146a3.354 3.354 0 100 6.709 3.354 3.354 0 000-6.709zm0-5.209a8.526 8.526 0 00-5.453 1.961l2.553 2.553c.816-.585 1.817-.93 2.899-.93s2.083.345 2.9.93l2.553-2.553a8.523 8.523 0 00-5.453-1.96z"/>'
  }
})
